import { j as s } from "../../../node_modules/react/jsx-runtime.js";
import l from "../../atoms/Accordion/Accordion.js";
import { memo as n } from "react";
import p from "./AccordionGroup.module.scss.js";
import { clsx as e } from "../../../node_modules/clsx/dist/clsx.m.js";
const f = n((i) => {
  const {
    accordionList: r,
    size: c = "medium",
    color: t = "white",
    isRounded: o = !0,
    spacing: m = "md"
  } = i;
  return /* @__PURE__ */ s.jsx("div", { className: e("flex flex-col", { [p[m]]: o }), children: r.map((d, a) => /* @__PURE__ */ s.jsx(
    l,
    {
      ...d,
      size: c,
      color: t,
      isRounded: o,
      spacing: m,
      className: e(!o && { "border-b-0": a !== r.length - 1 })
    }
  )) });
});
f.displayName = "AccordionGroup";
export {
  f as default
};
//# sourceMappingURL=AccordionGroup.js.map
